// get_registared_user_count
export const GET_REGISTARED_USER_COUNT = 'get_registared_user_count';
export const GET_REGISTARED_USER_COUNT_SUCCESSFUL =
  'get_registared_user_count_successfull';
export const GET_REGISTARED_USER_COUNT_FAILED =
  'get_registared_user_count_failed';

// get_user_count_chart
export const GET_USER_COUNT_CHART = 'get_user_count_chart';
export const GET_USER_COUNT_CHART_SUCCESSFUL =
  'get_user_count_chart_successfull';
export const GET_USER_COUNT_CHART_FAILED = 'get_user_count_chart_failed';

// get_view_all_users
export const GET_VIEW_ALL_USERS = 'get_view_all_users';
export const GET_VIEW_ALL_USERS_SUCCESSFUL = 'get_view_all_users_successfull';
export const GET_VIEW_ALL_USERS_FAILED = 'get_view_all_users_failed';

// get_registered_users
export const GET_REGISTERED_USERS = 'get_registered_users';
export const GET_REGISTERED_USERS_SUCCESSFUL =
  'get_registered_users_successfull';
export const GET_REGISTERED_USERS_FAILED = 'get_registered_users_failed';

// get_active_users
export const GET_ACTIVE_USERS = 'get_active_users';
export const GET_ACTIVE_USERS_SUCCESSFUL = 'get_active_users_successfull';
export const GET_ACTIVE_USERS_FAILED = 'get_active_users_failed';

// get_unregistared_users
export const GET_UNREGISTARED_USERS = 'get_unregistared_users';
export const GET_UNREGISTARED_USERS_SUCCESSFUL =
  'get_unregistared_users_successfull';
export const GET_UNREGISTARED_USERS_FAILED = 'get_unregistared_users_failed';

// get_user_activity
export const GET_USER_ACTIVITY = 'get_user_activity';
export const GET_USER_ACTIVITY_SUCCESSFUL = 'get_user_activity_successfull';
export const GET_USER_ACTIVITY_FAILED = 'get_user_activity_failed';
